import { hot } from 'react-hot-loader/root'
import Feeds from './components/Feeds'

export default hot(Feeds)